
import React from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaArrowUp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "./Footer.css";

function Footer() {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <footer className="footer">
        {/* Left Section */}
        <div className="footer-left">
          <img src="/images/logo.webp" alt="My School Logo" />
          <div className="footer-left-text">
            <h2>Academic Group of Schools</h2>
            <em>Since 2005</em>
          </div>
        </div>

        {/* Branches Section */}
        <div className="footer-branches">
          <h3>Our Branches</h3>
          <ul>
            <li>
              <Link to="/campuses/boys">1. Boys Branch, Chowk Shah Abbas</Link>
            </li>
            <li>
              <Link to="/campuses/girls">
                2. Girls Branch, Near Al-Jilan School
              </Link>
            </li>
            <li>
              <Link to="/campuses/rangilpur">3. Rangilpur Branch</Link>
            </li>
          </ul>
        </div>

        {/* Academics Section */}
        <div className="footer-academics">
          <h3>Academics</h3>
          <ul>
            <li>
              <Link to="/academics/primary">Primary School</Link>
            </li>
            <li>
              <Link to="/academics/middle">Middle School</Link>
            </li>
            <li>
              <Link to="/academics/high">High School</Link>
            </li>
          </ul>
        </div>

        {/* Contact Section (Reach out to us) */}
        <div className="footer-contact">
          <h3 className="contact-heading">Reach out to us</h3>
          <div className="contact-item">
            <FaMapMarkerAlt className="contact-icon" />
            <span>Chowk Shah Abbas, Suraj Kund road, Multan</span>
          </div>
          <div className="contact-item">
            <FaEnvelope className="contact-icon" />
            <span>academicgroupofschools@gmail.com</span>
          </div>
          <div className="contact-item">
            <FaPhoneAlt className="contact-icon" />
            <span>0304 7630462</span>
          </div>
        </div>

        {/* Social Section */}
        <div className="footer-right">
          <h3>SOCIAL</h3>
          <div className="social-icons">
            <a
              href="https://www.youtube.com/@Academicgroupofschools"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>

          
          </div>
        </div>
      </footer>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Academic Group of Schools</p>
        <div>
          <a href="#journal">Journal</a>
          <a href="#terms">Terms of Use</a>
          <a href="#privacy">Privacy Policy</a>
        </div>
        <p>
          Website by <strong>Farrukh Saleem</strong>
        </p>
      </div>

      {/* Back to Top Button */}
      <button
        className="back-to-top"
        onClick={scrollToTop}
        aria-label="Back to top"
      >
        <FaArrowUp />
      </button>
    </>
  );
}

export default Footer;
